import { TrackCodec } from "./types";

/**
 * A plain free-text track: lyrics, bols, annotations.
 *
 * The value is whatever the user typed, so every operation is essentially a
 * pass-through. It exists so that call sites can treat all track types the same
 * way rather than special-casing "the one that isn't encoded".
 */
export const simpleCodec: TrackCodec = {
    id: "simple",
    label: "Text",
    isFreeText: true,
    toParts: (value) => (value === "" ? [] : [{ text: value }]),
    toPlainText: (value) => value,
    // Preserved verbatim from the original inline layout arithmetic.
    measure: (value) => value.length * 10 + 10,
    countNotes: (value) => (value === "" ? 0 : 1),
    // Free-text subcells read as separate entries (preserves the original
    // Array.join() default, which is comma-separated).
    summariseCell: (subCells) => subCells.join(","),
};
